interface SymptomsMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const SymptomsMenu: React.FC<SymptomsMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={20}
            checked={!clear && displayValue === 20}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Chest Pain</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={21}
            checked={!clear && displayValue === 21}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Dyspnea</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={22}
            checked={!clear && displayValue === 22}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Fatigue</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={23}
            checked={!clear && displayValue === 23}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Heart Failure</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={24}
            checked={!clear && displayValue === 24}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Palpitations</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={25}
            checked={!clear && displayValue === 25}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Syncope</span>
        </label>
      </li>
    </ul>
  );
};

export default SymptomsMenu;
